import _ from 'underscore';

export function updateSovColumns(schema, sovColumnNames) {
  _.each(Object.keys(sovColumnNames), (sovColumnName) => {
    if (schema.properties.PerformanceMetrics.schema.properties[sovColumnName]) {
      schema.properties.PerformanceMetrics.schema // eslint-disable-line no-param-reassign
        .properties[sovColumnNames[sovColumnName]] =
          _.clone(schema.properties.PerformanceMetrics.schema.properties[sovColumnName]);
      delete schema.properties.PerformanceMetrics.schema.properties[sovColumnName]; // eslint-disable-line no-param-reassign, max-len
    }
  });
}
